import { useCallback } from 'react';
import { Chart } from '@frontend/charts';
import { useNavigate } from '@frontend/weave-router';
import { ARRoiConversionChart } from '../charts/ar-roi-conversion-chart';
import { ARRoiNoShowRateChart } from '../charts/ar-roi-no-show-rate-chart';
import { useARRoiShallowStore } from '../hooks/use-ar-roi-store';
import { useFetchARROIOOverview } from '../hooks/use-fetch-ar-roi-overview';
import { ARRoi } from '../types';

export const ARCharts = (props: ReturnType<typeof useFetchARROIOOverview>) => {
  const navigate = useNavigate();
  const { filters } = useARRoiShallowStore('filters');
  const showCompareMulti = (filters?.locationIds?.length || 0) > 1;

  const onShowMoreClick = useCallback((showMoreView: ARRoi) => {
    navigate({
      to: '/analytics/roi/appointment-reminders',
      search: { view: showMoreView },
    });
  }, []);

  return (
    <Chart.HorizontalContainer marginBottom={0}>
      <ARRoiConversionChart
        {...props}
        onShowMoreClick={() => onShowMoreClick('arConversion')}
        showCompareMulti={showCompareMulti}
      />
      <ARRoiNoShowRateChart
        {...props}
        onShowMoreClick={() => onShowMoreClick('noShowRate')}
        showCompareMulti={showCompareMulti}
      />
    </Chart.HorizontalContainer>
  );
};
